import { render, staticRenderFns } from "./SectorsDistributionChart.vue?vue&type=template&id=378726b4&"
import script from "./SectorsDistributionChart.vue?vue&type=script&lang=js&"
export * from "./SectorsDistributionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports